import PropTypes from 'prop-types';
import { RadialBarChart, RadialBar } from 'recharts';

const KidsDashboardSection1 = ({ kidsDetails, storyDetails }) => {
  console.log('kidsDetails', storyDetails);
  return (
    <div className="flex flex-col dark:text-shoorah-darkBg xl:flex-row lg:flex-col mt-2 gap-5">
      <div className="border-[1.5px] border-shoorah-borderGray text-sm lg:text-base lg:rounded-2xl rounded-xl md:p-6 p-4 bg-white flex flex-col dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder w-full lg:w-full xl:w-3/5">
        <div className="text-lg md:text-xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
          Kids details
        </div>
        <div className="flex justify-between flex-grow gap-y-4 flex-col mt-5">
          <div className="grid 2xl:grid-cols-4 lg:grid-cols-2 md:grid-cols-4 sm:grid-cols-2 grid-cols-1 2xl:gap-3 gap-4 mt-2">
            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
              <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                B2C Parents
              </div>
              <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {kidsDetails?.totalActiveB2CParents ? kidsDetails?.totalActiveB2CParents : 0}
                {/* {dashboardData.totalActiveUser ? dashboardData.totalActiveUser : 0} */}
              </div>
            </div>
            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
              <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
                B2B Parents
              </div>
              <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {kidsDetails?.totalActiveB2BParents ? kidsDetails?.totalActiveB2BParents : 0}
                {/* {dashboardData.totalActiveB2CUser ? dashboardData.totalActiveB2CUser : 0} */}
              </div>
            </div>
            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl 2xl:p-3 p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-shoorah-ggg">
              <div className="text-gray-400 dark:text-shoorah-darkBg text-[14px] font-medium">
                Inactive kids
              </div>
              <div className="text-black dark:text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {kidsDetails?.inactiveKids ? kidsDetails?.inactiveKids : 0}
                {/* {dashboardData.totalInactiveUser ? dashboardData.totalInactiveUser : 0} */}
              </div>
            </div>
            <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-shoorah-ggg">
              <div className="text-gray-400 dark:text-shoorah-darkBg text-[14px] font-medium">
                Deleted
              </div>
              <div className="text-black dark:text-shoorah-darkBg text-lg lg:text-2xl font-medium">
                {kidsDetails?.deletedKids ? kidsDetails?.deletedKids : 0}
                {/* {dashboardData.totalDeletedAccount ? dashboardData.totalDeletedAccount : 0} */}
              </div>
            </div>
          </div>
          {/* temp */}
          <>
            <div className="w-full flex justify-center items-center">
              <div className=" text-sm lg:text-xl flex">
                <span className=" text-lg lg:text-3xl mr-3">
                  {/* {dashboardData.totalUser ? dashboardData.totalUser : 0} */}
                  {kidsDetails?.totalKids || 0}
                </span>
                <div className="border-l border-gray-200"></div>
                <div className="ml-3 flex items-center">Total kids</div>
              </div>
            </div>
          </>
          <div className="hidden flex-col lg:flex-row gap-4 lg:text-base text-sm items-center justify-between mt-3">
            <div>
              <div className=" text-sm lg:text-xl flex">
                <span className=" text-lg lg:text-3xl mr-3">
                  {/* {dashboardData.totalUser ? dashboardData.totalUser : 0} */}0
                </span>
                <div className="border-l border-gray-200"></div>
                <div className="ml-3 flex items-center">Total kids</div>
              </div>
            </div>
            <div>
              <div className="w-full border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-[#D4D4D4] text-black dark:text-shoorah-darkBg">
                <div className="flex  items-center text-lg md:text-xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
                  Subscription count
                </div>
                <div className="flex mt-1">
                  <div className="text-sm flex">
                    <div>
                      One month:
                      <span className="ml-3 font-bold text-shoorah-darkBg">
                        {/* {dashboardData.monthlySubscribedCount
                          ? dashboardData.monthlySubscribedCount
                          : 0} */}
                        0
                      </span>
                    </div>
                  </div>

                  <div className="border-l border-black ml-3"></div>
                  <div className="ml-3 text-sm flex mr-3">
                    <div>
                      Six month:
                      <span className="ml-3 font-bold text-shoorah-darkBg">
                        {/* {dashboardData.sixMonthsSubscribedCount
                          ? dashboardData.sixMonthsSubscribedCount
                          : 0} */}
                        0
                      </span>
                    </div>
                  </div>

                  <div className="border-l border-black"></div>
                  <div className="ml-3 text-sm flex text-shoorah-darkBg">
                    <div>
                      Annual:
                      <span className="ml-3 font-bold text-shoorah-darkBg">
                        {/* {dashboardData.annualSubscribedCount
                          ? dashboardData.annualSubscribedCount
                          : 0} */}
                        0
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder w-full xl:w-2/5 lg:w-full">
        <div className="text-lg md:text-xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
          Media details
        </div>
        <div className="grid 2xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 2xl:gap-3 gap-4 mt-2">
          <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
            <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
              Total Mindfullness
            </div>
            <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
              {storyDetails?.summary?.totalPods ? storyDetails?.summary?.totalPods : 0}
              {/* {dashboardData.totalActiveUser ? dashboardData.totalActiveUser : 0} */}
            </div>
          </div>
          <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
            <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
              Total Audio Stories
            </div>
            <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
              {storyDetails?.summary?.totalStories ? storyDetails?.summary?.totalStories : 0}
              {/* {dashboardData.totalActiveB2CUser ? dashboardData.totalActiveB2CUser : 0} */}
            </div>
          </div>
          <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
            <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
              Total Lullabies
            </div>
            <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
              {storyDetails?.summary?.totalLullabies ? storyDetails?.summary?.totalLullabies : 0}
              {/* {dashboardData.totalActiveUser ? dashboardData.totalActiveUser : 0} */}
            </div>
          </div>
          <div className="h-[85px] flex justify-between flex-col border border-gray-300 rounded-xl p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder bg-blue-800 text-white">
            <div className="flex text-[14px] items-center font-medium text-shoorah-darkBg">
              Total Affirmation
            </div>
            <div className="text-shoorah-darkBg text-lg lg:text-2xl font-medium">
              {storyDetails?.summary?.totalAffirmation
                ? storyDetails?.summary?.totalAffirmation
                : 0}
              {/* {dashboardData.totalActiveUser ? dashboardData.totalActiveUser : 0} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

KidsDashboardSection1.propTypes = {
  kidsDetails: PropTypes.any,
  storyDetails: PropTypes.any
};

export default KidsDashboardSection1;
